import { Component, OnInit, Input } from '@angular/core';
import { Client } from 'src/app/shared/models/client.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClientShowkeyModalService } from './client-showkey-modal.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-client-showkey-modal',
  templateUrl: './client-showkey-modal.component.html',
  styleUrls: ['./client-showkey-modal.component.scss']
})
export class ClientShowkeyModalComponent implements OnInit {

  @Input() client: Client;
  
  constructor(public activeModal: NgbActiveModal,
              private toastr: ToastrService,
              private clientShowkeyModalService: ClientShowkeyModalService,
              private spinner: NgxSpinnerService) { }

  /**
   * 
   */
  ngOnInit() { }

  /**
   * 
   */
  copyApiKey(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.client.client_secret;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.toastr.info("El valor del apikey ha sido copiado correctamente");
  }

  /**
   * 
   */
  generateApiKey() {
    this.spinner.show();
    this.clientShowkeyModalService.generateApiKey(this.client.client_id).subscribe((result: any) => {
      this.spinner.hide();
      this.getClient();
      this.toastr.info("Un nuevo valor de apikey ha sido generado correctamente");
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
    });
  }

  /**
   * 
   */
  getClient() {
    this.spinner.show();
    this.clientShowkeyModalService.getClient(this.client.client_id).subscribe((result: Client) => {
      this.client = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
    });
  }
}
